// Підключення функціоналу "Чертоги Фрілансера"
// import { isMobile } from "./functions.js";
// // Підключення списку активних модулів
// import { flsModules } from "./modules.js";

// import { spollers } from './spollers.js';

import { isMobile, spollers } from "./functions.js";
import { flsModules } from "./modules.js";


document.addEventListener('DOMContentLoaded', function () {
  const videoBlocks = document.querySelectorAll('.js-about-video');

  videoBlocks.forEach(function (block) {
    const playBtn = block.querySelector('.about-video__play');
    if (!playBtn) return;

    playBtn.addEventListener('click', function () {
      const type = block.dataset.type;

      if (type === 'upload') {
        const videoSrc = block.dataset.video;
        if (!videoSrc) return;

        block.innerHTML = `
          <video
            class="about-video__media"
            controls
            autoplay
            playsinline
            preload="metadata"
          >
            <source src="${videoSrc}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        `;
      }

      if (type === 'youtube') {
        const youtubeId = block.dataset.youtubeId;
        if (!youtubeId) return;

        block.innerHTML = `
          <iframe
            class="about-video__media"
            src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1&playsinline=1"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        `;
      }
    });
  });
});


